import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {NotificationType} from '~core/enum';
import {Contact, Customer} from '~core/models';
import {ContactManagementService, DefaultNotificationService} from '~core/services';
import {ContactManagementTranslationsService, TooltipTranslationService} from '~shared/translations';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';

/**
 * Handles contact management.
 */
@UntilDestroy()
@Component({
  selector: 'app-contact-management-list',
  templateUrl: 'contact-management-list.component.html',
  styleUrls: ['../../../customer-overview.component.scss']
})
export class ContactManagementListComponent implements OnInit, OnDestroy {
  @Input() public customer: Customer;
  @Input() public isPanelOpened: boolean = true;
  @Output() public isPanelOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public contacts: Array<Contact>;
  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];
  public totalData: number;

  constructor(
    private notificationService: DefaultNotificationService,
    public contactManagementService: ContactManagementService,
    private contactManagementTranslations: ContactManagementTranslationsService,
    public customerOverviewService: CustomerOverViewService,
    public tablesTranslations: TablesTranslations,
    public tooltipTranslations: TooltipTranslationService,
  ) {
    this.contactManagementService.castContactList.pipe(untilDestroyed(this))
      .subscribe((data: Array<Contact>) => {
        if (data) {
          this.contacts = data;
        }
      });
    this.columns.push(
      '', this.tablesTranslations.i18nDate, this.tablesTranslations.i18nTitle,
      this.tablesTranslations.i18nComment, this.tablesTranslations.i18nAuthor
    );
    this.keys.push(['pinned', 'updatedAt', 'title', 'comment', 'fullName']);
  }

  /**
   * Create the form and fetch the countries and the current user
   */
  public ngOnInit(): any {
    this.getLatestContacts(this.customer.id);
  }

  public ngOnDestroy(): void {
  }

  /**
   * Get the contacts for the current customer.
   */
  public getLatestContacts(id: number): any {
    this.contactManagementService.getById(id, true).pipe(untilDestroyed(this))
      .subscribe({
        next: (data: Array<Contact>) => {
          this.contactManagementService.setContactList(data);
        },
        error: (error: Error) => {
          this.notificationService.showNotification({
            type: NotificationType.ALERT,
            message: this.contactManagementTranslations.i18nErrorFetchingContacts
          });
        }
      });
  }

  /**
   * Fill the contact form with user/admin and contact data
   */
  public fillContact(contact: Contact): void {
    this.contactManagementService.announceContactEdit(contact);
    this.customerOverviewService.toggleAllModal(false);
    this.customerOverviewService.toggleEditContactModal(true);
  }

  /**
   * Announce / notify change with activity history service.
   */
  public createNewContact(): void {
    this.contactManagementService.clearContactEdited();
    this.customerOverviewService.toggleAllModal(false);
    this.customerOverviewService.toggleNewContactModal(true);
  }
}
